import React from "react";
import moduleStyles from "../document.module.css";

/**
 * FreightWorkspaceShell - reusable container for freight workspace pages
 *
 * Provides consistent layout structure for:
 * - Filter/search form section
 * - Optional result header (badge, document count, etc.)
 * - Toolbar (View/Reset/Export + custom actions)
 * - Data grid
 */

interface FreightWorkspaceShellProps {
    /**
     * The search/filter form component (PartnerLookup, DatePicker, etc.)
     */
    searchForm: React.ReactNode;

    /**
     * Optional header content shown above toolbar (e.g., document count badge)
     */
    resultHeader?: React.ReactNode;

    /**
     * The toolbar component (FreightGridToolbar + custom actions)
     */
    toolbar: React.ReactNode;

    /**
     * The ag-grid component wrapper (AgGridReact in a div)
     */
    grid: React.ReactNode;

    /**
     * Optional CSS class for the container
     */
    containerClassName?: string;
}

const FreightWorkspaceShell: React.FC<FreightWorkspaceShellProps> = ({
    searchForm,
    resultHeader,
    toolbar,
    grid,
    containerClassName = "",
}) => {
    const shellClassName = [moduleStyles.freightWorkspaceShell, containerClassName].filter(Boolean).join(" ");

    return (
        <div className={shellClassName}>
            <section className={moduleStyles.freightWorkspaceSearch}>
                {searchForm}
            </section>

            {resultHeader && (
                <section className={moduleStyles.freightWorkspaceResultHeader}>
                    {resultHeader}
                </section>
            )}

            <section className={moduleStyles.freightWorkspaceToolbar}>
                {toolbar}
            </section>

            <section className={moduleStyles.freightWorkspaceGrid}>
                {grid}
            </section>
        </div>
    );
};

export default FreightWorkspaceShell;
